import {Component, inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {DxTabsModule} from "devextreme-angular";
import {BlockedStockScoreComponent} from "./blocked-stock-score/blocked-stock-score.component";
import {BlockedStockDataComponent} from "./blocked-stock-data/blocked-stock-data.component";
import {BlockedStockChartsComponent} from "./blocked-stock-charts/blocked-stock-charts.component";

@Component({
    selector: 'app-blocked-stock',
    imports: [DxTabsModule, BlockedStockScoreComponent, BlockedStockDataComponent, BlockedStockChartsComponent],
    templateUrl: './blocked-stock.component.html'
})
export class BlockedStockComponent {
    private route = inject(ActivatedRoute);
    private router = inject(Router);

    private readonly defaultTab = 'charts';

    tabs = [
        {text: 'My Score', id: 'charts'},
        {text: 'Score', id: 'score'},
        {text: 'Data', id: 'data'}
    ];

    selectedTabKeys: string[] = [this.defaultTab];

    constructor() {
        this.route.params.pipe(takeUntilDestroyed()).subscribe(params => {
            const tabParam = params['tab'];
            const validTab = this.tabs.find(t => t.id === tabParam);
            this.selectedTabKeys = [validTab?.id ?? this.defaultTab];
        });
    }

    async onTabClick(id: string) {
        await this.router.navigate(['/inventory/blocked-stock', id]);
    }
}
